<certificate-manager
  *authorize-read-write
  (identityDeleted)="notify($event)"
  (changeActive)="notify($event)"
  (identityAdded)="notify($event)"
  (groupDeleted)="notify($event)">
</certificate-manager>
